import { getCLS, getFID, getFCP, getLCP, getTTFB } from 'web-vitals';

// Performance monitoring function
export const initPerformanceMonitoring = () => {
  const sendToAnalytics = (metric) => {
    // Log to console in development
    if (process.env.NODE_ENV === 'development') {
      console.log('Performance Metric:', {
        name: metric.name,
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id
      });
    }
    
    // Send to Google Analytics 4 (if gtag is available)
    if (typeof window.gtag === 'function') {
      window.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        event_label: metric.id,
        non_interaction: true,
      });
    }
    
    // Send to Plausible Analytics (if plausible is available)
    if (typeof window.plausible === 'function') {
      window.plausible('Web Vitals', {
        props: {
          metric: metric.name,
          value: Math.round(metric.value),
          rating: metric.rating
        }
      });
    }

    // Alternative: Send to your own analytics endpoint
    /*
    if (process.env.NODE_ENV === 'production') {
      fetch('/api/analytics', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          metric: metric.name,
          value: metric.value,
          rating: metric.rating,
          id: metric.id,
          timestamp: Date.now()
        }),
        keepalive: true
      }).catch(console.error);
    }
    */
  };

  // Monitor Core Web Vitals
  getCLS(sendToAnalytics);  // Cumulative Layout Shift (< 0.1 is good)
  getFID(sendToAnalytics);  // First Input Delay (< 100ms is good)
  getFCP(sendToAnalytics);  // First Contentful Paint (< 1.8s is good)
  getLCP(sendToAnalytics);  // Largest Contentful Paint (< 2.5s is good)
  getTTFB(sendToAnalytics); // Time to First Byte (< 800ms is good)

  // Log initial performance info
  if (process.env.NODE_ENV === 'development' && performance.memory) {
    console.log('Initial Memory Usage:', {
      used: Math.round(performance.memory.usedJSHeapSize / 1048576) + 'MB',
      total: Math.round(performance.memory.totalJSHeapSize / 1048576) + 'MB',
      limit: Math.round(performance.memory.jsHeapSizeLimit / 1048576) + 'MB'
    });
  }
};

// Performance optimization utilities
export const performanceUtils = {
  // Check if user has slow connection
  isSlowConnection: () => {
    return navigator.connection && 
           (navigator.connection.effectiveType === 'slow-2g' || 
            navigator.connection.effectiveType === '2g' ||
            navigator.connection.saveData);
  },

  // Check if user prefers reduced motion
  prefersReducedMotion: () => {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  },

  // Check if device has low memory
  isLowMemoryDevice: () => {
    return navigator.deviceMemory && navigator.deviceMemory < 4;
  },

  // Get device performance tier
  getPerformanceTier: () => {
    const memory = navigator.deviceMemory || 4;
    const cores = navigator.hardwareConcurrency || 2;
    
    if (memory >= 8 && cores >= 4) return 'high';
    if (memory >= 4 && cores >= 2) return 'medium';
    return 'low';
  }
};